import { initializeApp } from 'firebase/app';
import { getRemoteConfig } from 'firebase/remote-config';

const ONE_MINUTE = 60000;
const ONE_HOUR = ONE_MINUTE * 60;

const appIdDev = '1:162854071645:web:73fe7ed31b7fb1ed990cb4';
const appIdAcc = '1:162854071645:web:07a6f2badaea952b990cb4';
const appIdProd = '1:162854071645:web:fa3eadb4b2f62e27990cb4';

const getAppId = (environment: string) => {
  if (environment === 'acc') return appIdAcc;
  if (environment === 'dev') return appIdDev;
  if (environment === 'prod') return appIdProd;
  return appIdDev;
};

export function getRemoteConfigByEnvironment(environment: string) {
  const firebaseConfig = {
    apiKey: 'AIzaSyBtEFqD9Kl9dR_4BfB3rKEmph2LNigRgBs',
    authDomain: 'customer-extranet-fla.firebaseapp.com',
    projectId: 'customer-extranet-fla',
    storageBucket: 'customer-extranet-fla.firebasestorage.app',
    messagingSenderId: '162854071645',
    appId: getAppId(environment),
  };

  const app = initializeApp(firebaseConfig);
  const remoteConfig = getRemoteConfig(app);

  remoteConfig.settings = {
    minimumFetchIntervalMillis: ONE_HOUR,
    fetchTimeoutMillis: ONE_MINUTE,
  };

  return remoteConfig;
}
